import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

// UTILITY
import { getSecureCardNumberValue, formatCardExpValue } from '@/utility/subscription';

// STYLES
import { SCardFieldsWrapper } from './styles';

function CardFields({ card, className }) {
  const [t] = useTranslation();

  const cardNumberValue = getSecureCardNumberValue(card.last4);
  const cardExpValue = formatCardExpValue(card.exp_month, card.exp_year);

  return (
    <SCardFieldsWrapper className={className}>
      <Grid container spacing={3}>
        <Grid item xs={7}>
          <TextField
            label={t('inputs.creditCardNum')}
            name="ccnumber"
            fullWidth
            size="small"
            disabled
            value={cardNumberValue}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={5}>
          <TextField
            label={t('inputs.expDate')}
            name="ccexp"
            fullWidth
            size="small"
            disabled
            value={cardExpValue}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
      </Grid>
    </SCardFieldsWrapper>
  );
}

CardFields.propTypes = {
  card: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default React.memo(CardFields);
